// shakeTable.js
var ShakeTable = pc.createScript('shakeTable');

ShakeTable.attributes.add("GameBoard", { type: "entity" });
ShakeTable.attributes.add("Rigid", { type: "entity" });
ShakeTable.attributes.add("Cover", { type: "entity" });
ShakeTable.attributes.add("ShakeWalls", { type: "entity" });
ShakeTable.attributes.add("JokerButton", {type: "entity"});

ShakeTable.prototype.initialize = function () {

    ShakeTable.instance = this;
    this.buttonStatus = false;
    this.objectOnTheCover = null;

    // if (PlayerManager.instance.userData.shakeTutorial == undefined || PlayerManager.instance.userData.shakeTutorial == "0" || PlayerManager.instance.userData.shakeTutorial == null || PlayerManager.instance.userData.shakeTutorial == false) {
    //     this.entity.children[3].enabled = true;
    //     GameManager.instance.PauseGame();
    // }
    // else {
    //     this.entity.children[3].enabled = false;
    // }

    this.entity.button.on('click', function () {
        this.buttonStatus = false;
        // Timer.instance.PauseTimer();
        // TimeBar.instance.pauseBar();
        // Touch.instance.Pause();

        ShakeTable.instance.entity.enabled = false;

        //if (GameAnalyticsSdk.instance.gaStatus) {GameAnalytics("addDesignEvent", "ShakeButton:Click", 1);}

        if (PlayerManager.instance.userData.gameMode == gamePlayMode.MiniGame) {
            this.JokerButton.enabled = false;
        }
        
        if (PlayerManager.instance.userData.shakeTutorial == undefined || PlayerManager.instance.userData.shakeTutorial == false) {
            PlayerManager.instance.userData.shakeTutorial = true;
            PlayerManager.instance.SavePlayerData();

            // this.entity.children[3].enabled = false;
            // this.shakeAnimation();
        }
        rewardedType = adsType.ShakeExtraTime;
        if (gdsdk !== 'undefined' && gdsdk.preloadAd !== 'undefined') {
            gdsdk.showAd('rewarded')
                .then(response => {
                })
                .catch(error => {
                    ShakeTable.instance.shakeAnimation();
                    console.log("Error Rewarded ADS");
                });
        }
    }, this);
    
    
};

ShakeTable.prototype.shakeAnimation = function() {

    this.Rigid.rigidbody.type = pc.BODYTYPE_KINEMATIC;
        ShakeTable.instance.Cover.rigidbody.enabled = false;
        ShakeTable.instance.Cover.collision.enabled = false;
        ShakeTable.instance.Cover.enabled = false;
        ShakeTable.instance.ShakeWalls.enabled = true;
        
        if (spawnPositions[0].findByTag("dropped").length == 1) {

            this.objectOnTheCover = spawnPositions[0].findByTag("dropped")[0];
            ShakeTable.instance.shakeObjectOnTheCoverStageOne();
        }
        this.shakeStageOne();
};

ShakeTable.prototype.shakeStageOne = function () {

    ShakeTable.instance.GameBoard
        .tween(ShakeTable.instance.GameBoard.getLocalEulerAngles())
        .rotate(new pc.Vec3(0, 0, -30), 0.15, pc.Linear)
        .yoyo(true)
        .repeat(2)
        .on('complete', function () {

            ShakeTable.instance.GameBoard
                .tween(ShakeTable.instance.GameBoard.getLocalEulerAngles())
                .rotate(new pc.Vec3(0, 0, 30), 0.15, pc.Linear)
                .yoyo(true)
                .repeat(2)
                .on('complete', function () {
                    ShakeTable.instance.shakeStageTwo();
                })
                .start();
        })
        .start();
};

ShakeTable.prototype.shakeStageTwo = function() {
        
        ShakeTable.instance.GameBoard
            .tween(ShakeTable.instance.GameBoard.getLocalEulerAngles())
            .rotate(new pc.Vec3(0, 0, -30), 0.10, pc.Linear)
            .yoyo(true)
            .repeat(2)
            .on('complete', function () {

                ShakeTable.instance.GameBoard
                    .tween(ShakeTable.instance.GameBoard.getLocalEulerAngles())
                    .rotate(new pc.Vec3(0, 0, 30), 0.10, pc.Linear)
                    .yoyo(true)
                    .repeat(2)
                    .on('complete', function () {
                        ShakeTable.instance.shakeStageThree();
                    })
                    .start();
            })
            .start();
};

ShakeTable.prototype.shakeStageThree = function() {
        
        ShakeTable.instance.GameBoard
            .tween(ShakeTable.instance.GameBoard.getLocalEulerAngles())
            .rotate(new pc.Vec3(0, 0, -30), 0.05, pc.Linear)
            .yoyo(true)
            .repeat(2)
            .on('complete', function () {

                ShakeTable.instance.GameBoard
                    .tween(ShakeTable.instance.GameBoard.getLocalEulerAngles())
                    .rotate(new pc.Vec3(0, 0, 30), 0.05, pc.Linear)
                    .yoyo(true)
                    .repeat(2)
                    .on('complete', function () {
                        
                        setTimeout(() => {
                            ShakeTable.instance.entity.enabled = true;

                            if (PlayerManager.instance.userData.gameMode == gamePlayMode.MiniGame) {
                                ShakeTable.instance.JokerButton.enabled = true;
                            }

                        }, 700, this);
                        
                        ShakeTable.instance.Rigid.rigidbody.type = pc.BODYTYPE_STATIC;
                        ShakeTable.instance.Cover.rigidbody.enabled = true;
                        ShakeTable.instance.Cover.collision.enabled = true;
                        ShakeTable.instance.Cover.enabled = true;
                        ShakeTable.instance.ShakeWalls.enabled = false;
                        GameManager.instance.ResumeGame();
                    })
                    .start();
                
            })
            .start();
};


ShakeTable.prototype.shakeObjectOnTheCoverStageOne = function() {
        
        ShakeTable.instance.objectOnTheCover
            .tween(ShakeTable.instance.objectOnTheCover.getLocalEulerAngles())
            .rotate(new pc.Vec3(0, 0, -30), 0.15, pc.Linear)
            .yoyo(true)
            .repeat(2)
            .on('complete', function () {

                ShakeTable.instance.objectOnTheCover
                    .tween(ShakeTable.instance.objectOnTheCover.getLocalEulerAngles())
                    .rotate(new pc.Vec3(0, 0, 30), 0.15, pc.Linear)
                    .yoyo(true)
                    .repeat(2)
                    .on('complete', function () {
                        ShakeTable.instance.shakeObjectOnTheCoverStageTwo();
                    })
                    .start();
            })
            .start();
};

ShakeTable.prototype.shakeObjectOnTheCoverStageTwo = function() {
        
        ShakeTable.instance.objectOnTheCover
            .tween(ShakeTable.instance.objectOnTheCover.getLocalEulerAngles())
            .rotate(new pc.Vec3(0, 0, -30), 0.10, pc.Linear)
            .yoyo(true)
            .repeat(2)
            .on('complete', function () {

                ShakeTable.instance.objectOnTheCover
                    .tween(ShakeTable.instance.objectOnTheCover.getLocalEulerAngles())
                    .rotate(new pc.Vec3(0, 0, 30), 0.10, pc.Linear)
                    .yoyo(true)
                    .repeat(2)
                    .on('complete', function () {
                        ShakeTable.instance.shakeObjectOnTheCoverStageThree();
                    })
                    .start();
            })
            .start();
};

ShakeTable.prototype.shakeObjectOnTheCoverStageThree = function () {

    ShakeTable.instance.objectOnTheCover
        .tween(ShakeTable.instance.objectOnTheCover.getLocalEulerAngles())
        .rotate(new pc.Vec3(0, 0, -30), 0.05, pc.Linear)
        .yoyo(true)
        .repeat(2)
        .on('complete', function () {

            ShakeTable.instance.objectOnTheCover
                .tween(ShakeTable.instance.objectOnTheCover.getLocalEulerAngles())
                .rotate(new pc.Vec3(0, 0, 30), 0.05, pc.Linear)
                .yoyo(true)
                .repeat(2)
                .start();

        })
        .start();
};


